import React, { useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { useWindowSize } from "@react-hook/window-size";
import { Row, Col, Input, FormGroup, Label, Button } from "reactstrap";
import Strip from "../customComponent/Strip/Strip";
import ExternalLayout from "../customComponent/ExternalLayout/ExternalLayout";
import RenderPage from "../customComponent/RenderPage/RenderPage";
import SEOComponent from "../customComponent/SEO/SEOComponent";
import CustomPagination from "./Home/CustomPagination";
import application_contants from "../constants/application_contant";
import getPatients from "../../api/services/getPatients";

const AddPatient = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const perPage = 10; // Change this to the number of cards per page
  // const totalCards = data.length; // Assuming 'data' is the array of cards
  // const totalPages = Math.ceil(totalCards / perPage);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `http://15.207.223.68:5000/getPatientslist?page=${currentPage}&pageSize=${perPage}`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        console.log("Fetch Result:", result);

        if (result && result.patients && Array.isArray(result.patients.rows)) {
          setData(result.patients.rows);
          setTotalPages(result.totalPages || 1);
        } else {
          console.error("Invalid response format:", result);
        }
      } catch (error) {
        console.error("Error fetching patient data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [currentPage]);

  useEffect(() => {
    console.log("Data Length:", data.length); // Add this log
  }, [data]);

  console.log("Data:", data);
  console.log("Current Page:", currentPage);
  console.log("Total Pages:", totalPages);

  return (
    <ExternalLayout>
      <RenderPage
        id="tst-landing"
        className={`render px-0 render-page`}
        containerType="container-fluid"
      >
        <Strip
          id="tst-strip-Video"
          className="strip strip-no-padding "
          containerType="container-fluid mb-5 mt-5"
        >
          <SEOComponent
            title="Patients"
            keywords="Patients"
            description="Antlia"
            siteUrl="/Antlia"
          />
          <Row className="mx-0 background-container container mx-5">
            <Col
              xs={11}
              sm={11}
              md={11}
              lg={11}
              xl={11}
              className="m-auto pt-4 pl-5"
            >
              <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="pt-3">
                  <p className="p-small title-bold2 align-left">
                    <span className="p-small section-title move-right title-bold1">
                      Patients
                    </span>
                    <span className="vertical-line section-title">
                      {" "}
                      Apollo Care Hospital
                    </span>
                  </p>
                </Col>

                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="">
                  <CustomPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    resultsPerPage={perPage}
                    totalPatients={data.length}
                  />
                  {data.length > 0 ? (
                    <Row>
                      {data.map((item, index) => {
                        console.log("Patient:", item);
                        return (
                          <Col
                            xs={12}
                            sm={12}
                            md={6}
                            lg={6}
                            xl={6}
                            key={index}
                            className=""
                          >
                            <Row className="mx-0 pt-2">
                              <Col
                                xs={12}
                                sm={12}
                                md={11}
                                lg={11}
                                xl={11}
                                className=" challenges-card-br123 "
                              >
                                <div>
                                  <div className="card-icon">
                                    <img
                                      src={application_contants.editingimg}
                                      alt="Icon 1"
                                    />
                                    <img
                                      src={application_contants.Deleteimg}
                                      alt="Icon 2"
                                    />
                                  </div>
                                  <p className="section-title1 align-left p-1 ">
                                    <span className="p-small title-bold3 ">
                                      {item.firstname}
                                    </span>
                                    <span className="section-title1 patient-id">
                                      ID: {item.patient_id}
                                    </span>
                                  </p>
                                  <p className="p-very-small section-title1 align-left p-1 ">
                                    {item.dob} | {item.gender} | {item.smoker}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        );
                      })}
                    </Row>
                  ) : (
                    <Row className="mx-0">
                      <Col xs={12} sm={12} md={12} lg={12} xl={12} className="">
                        <h2 className="h5-small section-title align-left pt-5 title-navy-blue-medium">
                          Coming soon ....
                        </h2>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          );
        </Strip>
      </RenderPage>
    </ExternalLayout>
  );
};

export default AddPatient;
